import { FC, useState } from 'react';
import Lottie from 'lottie-react';
import groovyWalkAnimation from './Json/faceAnimation.json';
import SignUp from './components/SignUp';
import Login from './components/Login';
import { BrandLogoIcon, ScaleTechIcon } from './Icons/Icon';

const AuthContainer: FC = () => {
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');
  const toggleAuthMode = () => {
    setAuthMode((prevMode) => (prevMode === 'login' ? 'signup' : 'login'));
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-left-container">
        <div className="logo--wrapper">
          <BrandLogoIcon />
        </div>
        <div className="animated-image">
          <Lottie animationData={groovyWalkAnimation} loop={true} />
        </div>
      </div>

      <div className="auth-right-container">
        <div className="auth-form-container">
          <h1 className="auth-title">{authMode === 'login' ? 'Login' : 'Sign Up'}</h1>
          <div className="auth-form-wrapper" style={{ minHeight: '240px' }}>
            {authMode === 'login' ? <Login onSwitch={toggleAuthMode} /> : <SignUp onSwitch={toggleAuthMode} />}
          </div>
        </div>
        <div className="bottom-text">
          <span className="footer-text">Powered by</span> <ScaleTechIcon />
        </div>
      </div>
    </div>
  );
};

export default AuthContainer;
